<template>
  <div class="hab-detail-utility">
    <div v-if="isLoading" class="text-center">
      <compLoading />
    </div>
    <div v-if="!isLoading && !dataUtility" class="not-data">Not Data</div>
    <div v-if="!isLoading">
      <div v-if="dataUtility">
        <div v-if="!isEmpty(utilityList)">
          <div
            v-for="(item, index) in utilityList"
            :key="index"
            class="hab-detail-utility-list"
          >
            <CompFlex align="center" wrap="wrap" gap="10">
              <div class="img">
                <img
                  :src="`https://${item.icon_url}`"
                  :alt="locale === 'vn' ? item.name : item.english_name"
                />
              </div>
              <h5 class="text-14-400 m-0 color-black">
                {{ locale === "vn" ? item.name : item.english_name }}
              </h5>
            </CompFlex>
            <div
              v-if="item.description || item.english_description"
              class="text-14-400 m-0 mt-12 color-light-black"
              style="line-height: 160%"
              v-html="
                locale === 'vn'
                  ? item.description.replace(/(?:\r\n|\r|\n)/g, '<br />')
                  : item.english_description.replace(
                      /(?:\r\n|\r|\n)/g,
                      '<br />'
                    )
              "
            />
          </div>
        </div>
        <CompFlex
          v-if="!isEmpty(utilityNotDescList)"
          align="center"
          wrap="wrap"
          className="hab-detail-utility-list-not-desc"
        >
          <div v-for="(item, index) in utilityNotDescList" :key="index">
            <CompFlex align="center" wrap="wrap" gap="10">
              <div class="img">
                <img :src="`https://${item.icon_url}`" :alt="item.name" />
              </div>
              <h5 class="text-14-400 m-0 color-black">{{ item.name }}</h5>
            </CompFlex>
          </div>
        </CompFlex>
      </div>
    </div>
  </div>
</template>

<script>
import compLoading from "../../../loading/index";
import CompFlex from "../../../flex/index.vue";
import { isEmpty } from "lodash";

export default {
  components: {
    compLoading,
    CompFlex,
  },
  props: {
    operatorId: {
      type: [Number, String],
      default: 0,
    },
    seatTemplateId: {
      type: [Number, String, null],
      default: null,
    },
  },
  computed: {
    utilityList() {
      return (
        this.dataUtility?.filter(
          (e) => e?.description || e?.english_description
        ) ?? []
      );
    },
    utilityNotDescList() {
      return (
        this.dataUtility?.filter(
          (e) => !e?.description && !e?.english_description
        ) ?? []
      );
    },
  },
  data() {
    return {
      locale: locale,
      isLoading: false,
      dataUtility: [],
    };
  },
  methods: {
    isEmpty,
    callAPI() {
      this.isLoading = true;
      this.$store
        .dispatch("getUtility", {
          id: this.operatorId,
          seat_template_id: this.seatTemplateId,
        })
        .then((result) => {
          this.isLoading = false;
          this.dataUtility = result;
        });
    },
  },
  mounted() {
    this.callAPI();
  },
};
</script>

<style lang="scss" scoped></style>
